import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchHotelCities } from "../api/apiService";

export default function HotelResults() {
  const locationHook = useLocation();
  const navigate = useNavigate();
  const payload = locationHook.state?.payload;

  const [hotelDetails, setHotelDetails] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!payload) return;

    const loadHotels = async () => {
      try {
        const res = await fetchHotelCities(payload);
        if (res?.HotelDetails) setHotelDetails(res.HotelDetails);
        else console.error("No HotelDetails in response", res);
      } catch (err) {
        console.error("Error fetching hotels:", err);
      } finally {
        setLoading(false);
      }
    };

    loadHotels();
  }, [payload]);

  if (!payload) return (
    <div>
      <p>No search data found.</p>
      <button onClick={() => navigate("/")}>Go Back</button>
    </div>
  );

  if (loading) return <p>Loading hotels...</p>;

  return (
    <div>
      <h2>Hotel Search Results</h2>
      {hotelDetails.length === 0 ? (
        <p>No hotels found.</p>
      ) : hotelDetails.map(hotel => (
        <div key={hotel.HotelCode}>
          <h3>{hotel.HotelName}</h3>
          <p dangerouslySetInnerHTML={{ __html: hotel.Description || "No description" }} />
          <p><strong>Address:</strong> {hotel.Address}</p>
          <p><strong>Rating:</strong> {hotel.HotelRating}</p>
          <p><strong>Phone:</strong> {hotel.PhoneNumber}</p>
          <p><strong>City:</strong> {hotel.CityName}, {hotel.CountryName}</p>
          <div>
            {hotel.Images?.map((img, i) => (
              <img key={i} src={img} alt={hotel.HotelName} style={{ width: "150px", margin: "5px" }} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
